exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".HistoryParameters-HistoryParametersFilterbox-column_superior{width:33%;background:#fff}.HistoryParameters-HistoryParametersFilterbox-column_softener{width:25%;background:#fff}.HistoryParameters-HistoryParametersFilterbox-Table_container{width:100%;border-spacing:0;border-collapse:collapse}.HistoryParameters-HistoryParametersFilterbox-table_border{padding:10px}", ""]);

// exports
exports.locals = {
	"column_superior": "HistoryParameters-HistoryParametersFilterbox-column_superior",
	"column_softener": "HistoryParameters-HistoryParametersFilterbox-column_softener",
	"Table_container": "HistoryParameters-HistoryParametersFilterbox-Table_container",
	"table_border": "HistoryParameters-HistoryParametersFilterbox-table_border"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-rules-2!./node_modules/postcss-loader/lib??ref--2-rules-3!./src/components/HistoryParameters/HistoryParametersFilterbox.css
// module id = 1100
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20